// Single source of truth for form element types.
// Keep this in sync with the shared mongoose_models `Question.type` enum and the
// answer renderer registry in ./responses/answerRenderers.jsx.

export const SHORT_QUESTION = 'Short question';
export const LONG_QUESTION = 'Long question';
export const DROPDOWN = 'Dropdown';

// Planned element types. The shared Question schema and the feedback submit
// endpoint must support these before they can store data, but the responses
// display is already built to render them (see answerRenderers).
export const CHECKBOXES = 'Checkboxes';
export const IMAGE = 'Image';
export const FILE = 'File';

export const QUESTION_TYPES = {
	SHORT_QUESTION,
	LONG_QUESTION,
	DROPDOWN,
	CHECKBOXES,
	IMAGE,
	FILE,
};
